var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00001 7.04091C8.12717 7.04091 9.04091 6.12717 9.04091 5.00001C9.04091 3.87285 8.12717 2.95911 7.00001 2.95911C5.87285 2.95911 4.95911 3.87285 4.95911 5.00001C4.95911 6.12717 5.87285 7.04091 7.00001 7.04091Z",
    fill: "#3D4756"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7508 3.68312C11.9594 2.39428 10.1593 0.231934 6.99999 0.231934C3.84066 0.231934 2.04058 2.39428 1.24922 3.68312C0.750261 4.49015 0.750261 5.50987 1.24922 6.31692C2.04058 7.60576 3.84066 9.76811 6.99999 9.76811C10.1593 9.76811 11.9594 7.60576 12.7508 6.31692C13.2497 5.50987 13.2497 4.49015 12.7508 3.68312ZM6.99999 8.06137C5.30925 8.06137 3.93862 6.69074 3.93862 5.00001C3.93862 3.30927 5.30925 1.93864 6.99999 1.93864C8.69072 1.93864 10.0614 3.30927 10.0614 5.00001C10.0597 6.69005 8.69003 8.05967 6.99999 8.06137Z",
    fill: "#3D4756"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.3a846c2d8d3a0fc15e207a77d23159a9.svg";
export { ForwardRef as ReactComponent };